const userAccess = {
  blockListUpload: ['developer', 'driverOps'],
  mustRequest: ['developer', 'driverOps'],
  bulkAssign: ['developer', 'driverOps'],
};

const groupAccess = {};

export { userAccess, groupAccess };
